import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Cards, Container, Flashbar, FlashbarProps, FormField, SpaceBetween, Textarea, Tiles } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Icon from '@mdi/react';
import { mdiContentSave, mdiBoomGateUp } from '@mdi/js';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { useStoreAdmin } from '../../../context/useStoreAdmin';

const pageSize = 20;
interface Access {
    idAcceso: number;
    relay: number;
    acceso: string;
    isOnline: number;
    manualOpenEnable: number;
    idSector: number;
    sector: string;
    label: string;
    id: string;
    description?: string
    disabled?: boolean;
}

interface Sector {
    idSector: number;
    sector: string;
}
export const NotificationsManualPage = () => {
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const storeAdmin = useStoreAdmin();
    const [accesses, setAccesses] = useState<Access[]>([]); // Initialize as an empty array
    const { JWT, setJWT } = useGlobalState();
    const { propiedad } = useGlobalState();  // Stores selected row data
    const { setLoading } = useGlobalState();
    const [selectedAccess, setSelectedAccess] = useState('');
    const [sectors, setSectors] = useState<Sector[]>([]);
    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();


    const handleOpen = async () => {
        if (idAcceso === "") {
            setMessages([
                {
                    type: "warning",
                    content: `Debe seleccionar el acceso`,
                    id: 'status200',
                    dismissible: true,
                    onDismiss: () => setMessages([]),
                },
            ]);
            return;
        }
        if (reason.length < 10) {
            setMessages([
                {
                    type: "warning",
                    content: `Motivo de apertura inválido`,
                    id: 'status200',
                    dismissible: true,
                    onDismiss: () => setMessages([]),
                },
            ]);
            return;
        }

        let body = {
            idAcceso: idAcceso,
            reason: reason
        }

        try {

            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/notifications/manual',
                    'JWT': JWT,

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            storeAdmin(data);
            if (data && data.result) {
                if (data.result.code === 1) {

                    setMessages([
                        {
                            type: "success",
                            content: data.result.status,
                            id: 'status200',
                            dismissible: true,
                            onDismiss: () => setMessages([]),
                        },
                    ]);

                    setReason("")
                    setIdAcceso("");
                } else {

                    setMessages([
                        {
                            type: "error",
                            content: data.result.status,
                            id: 'status400',
                            dismissible: true,
                            onDismiss: () => setMessages([]),
                        },
                    ]);
                }
                setTimeout(function () {
                    setMessages([])
                }, 3000)

            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };

    const handleRefresh = async () => {
        try {

            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/properties/accesses/list',
                    'JWT': JWT,

                },
                body: JSON.stringify({

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            storeAdmin(data);

            if (data.code === 0) {
            }

            // Assuming the accesses are available in data.admin.accesses
            if (data && data.accesses) {
                const simplifiedAccesses = data.accesses.map((item: any): Access => ({
                    idAcceso: item.idAcceso,
                    relay: item.relay,
                    acceso: item.acceso,
                    isOnline: item.isOnline,
                    manualOpenEnable: item.manualOpenEnable,
                    idSector: item.idSector,
                    sector: item.sector,
                    label: item.sector,
                    id: item.idSector,
                    disabled: item.manualOpenEnable === 0,
                    description: item.manualOpenEnable === 0 ? "Apertura manual deshabilitada" : "",
                }));
                setAccesses(simplifiedAccesses)
            } else {
                setAccesses([]); // Set to empty array if no accesses are found
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);

        }
    };


    useEffect(() => {
        const sectorFormFields = Array.from(
            new Map(
                accesses
                    .sort((a, b) => a.sector.localeCompare(b.sector)) // sort alphabetically by sector
                    .map((item) => [item.idSector, { idSector: item.idSector, sector: item.sector }])
            ).values()
        );
        setSectors(sectorFormFields)
    }, [accesses]);
    useEffect(() => {
        handleRefresh();
    }, []);
    const handleOption = (ref: string) => {
        window.location.href = ref
    }
    const [reason, setReason] = React.useState("");
    const [idAcceso, setIdAcceso] = React.useState("");
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Notificaciones', href: '#notifications' },
                        { text: 'Apertura Manual', href: '#transcription-job-list' },
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Container
                        header={
                            <>      <h3>Apertura manual</h3></>

                        }
                        footer={
                            <Box textAlign='right'><Button variant='primary' onClick={handleOpen}><Icon path={mdiBoomGateUp} color={'white'}
                                size={1} />Aperturar</Button></Box>
                        }
                    ><SpaceBetween direction='vertical' size='xs'>
                            <Flashbar items={messages} />

                            {sectors.map(({ idSector, sector }) => {
                                const sectorAccesses = accesses
                                    .filter(access => access.idSector === idSector)
                                    .map(({ idAcceso, acceso, manualOpenEnable, disabled, description, relay }) => ({
                                        value: idAcceso.toString(),
                                        label: acceso,
                                        disabled:(manualOpenEnable===0 || relay===0),
                                        description: 
                                        relay===0 ? "Acceso virtualizado" : 
                                        (manualOpenEnable===0 ? "Apertura manual deshabilitada" : "")
                                    }));

                                return (
                                    <FormField key={idSector} label={`Sector ${sector}`}>
                                        <Tiles
                                            items={sectorAccesses}
                                            value={idAcceso}
                                            onChange={({ detail }) => {
                                                setMessages([]); setIdAcceso(detail.value)
                                                if (inputRef.current) {
                                                    inputRef.current.focus(); // Focus the input
                                                }
                                            }}
                                        />
                                    </FormField>
                                );
                            })}
                            <FormField
                                label='Motivo de apertura'
                            >
                                <Textarea
                                    onChange={({ detail }) => { setMessages([]); setReason(detail.value) }}
                                    value={reason}
                                    placeholder="Motivo de apertura"
                                    ref={inputRef}
                                />
                            </FormField>
                        </SpaceBetween>
                    </Container>
                </>
            }
        />
    );
};
